import { GTM } from 'lib/core/services/gtm'
import { CartProduct } from 'lib/core/services/gtm/types'
import { CartItem } from '../../cart/types'

interface TriggerRemoveFromCartParams {
  cartItem: CartItem
}

export const triggerRemoveFromCart = ({
  cartItem
}: TriggerRemoveFromCartParams) => {
  const removedItems: CartProduct[] = []
  const { product, quantity } = cartItem
  const { sku, name } = product

  removedItems.push({
    id: sku,
    name: name,
    quantity
  })

  if (removedItems.length) {
    GTM.removeFromCart({
      products: removedItems
    })
  }
}
